module.exports = __webpack_public_path__ + "static/assets/9278474958d17ca2b79b64777503e898.svg";